export const tagTypes = {
  TAG: "TAG",
  CATEGORY: "CATEGORY",
  SUBCATEGORY: "SUBCATEGORY",
  MAPPING : "MAPPING"
};

export const tagsTableHeading = [
  {
    text: "S.No.",
    dataField: "sNo",
  },
  {
    text: "Tag Name",
    dataField: "name",
  },
  {
    text: "Description",
    dataField: "description",
  },
];
export const RestoreTableHeading = [
  {
    text: "S.No.",
    dataField: "sNo",
  },
  {
    text: "Tag Name",
    dataField: "name",
  },
  {
    text: "Description",
    dataField: "description",
  },
];
export const categorieTableHeading = [
  {
    text: "S.No.",
    dataField: "sNo",
  },
  {
    text: "Categories Name",
    dataField: "name",
  },
  {
    text: "Description",
    dataField: "description",
  },
];

export const subCategoriesTableHeading = [
  {
    text: "S.No.",
    dataField: "sNo",
  },
  {
    text: "Sub Categories Name",
    dataField: "name",
  },
  {
    text: "Description",
    dataField: "description",
  },
];
export const MappingList = [
  {
    text: "S.No.",
    dataField: "sNo",
  },
  {
    text: "Categories",
    dataField: "name",
  },
  {
    text: "SubCategories",
    dataField: "subName",
  },
];
export const RestoreTableHeadingForMapping = [
  {
    text: "S.No.",
    dataField: "sNo",
  },
  {
    text: "Categories",
    dataField: "name",
  },
  {
    text: "SubCategories",
    dataField: "subName",
  },
];

